<template>
    <kiosk-layout formContainer>
        <form-container>
            <step-form-heading :icon="faArrowsDownToPeople">
                New Import

                <template v-slot:description>
                    Create and update Voxie users in bulk. Existing users outside this team are invited by email.
                </template>
            </step-form-heading>

            <form-wrapper
                :sections="[
                    { id: 'template', label: 'Template' },
                    { id: 'upload', label: 'Upload' },
                ]"
            >
                <kiosk-team-user-import-new-template id="template"></kiosk-team-user-import-new-template>
                <div id="upload">
                    <kiosk-team-user-import-new-upload @selected="selectedFile"></kiosk-team-user-import-new-upload>
                </div>

                <vx-sticky-footer>
                    <vx-button
                        :href="`/kiosk/teams/${props.teamId}/users/imports`"
                        class="w-20"
                        size="lg"
                        color="muted"
                    >
                        Cancel
                    </vx-button>
                    <vx-button
                        @click="submit()"
                        data-test="submit-button"
                        :disabled="!file"
                        class="grow"
                        size="lg"
                        color="primary"
                        :loading="submitting"
                    >
                        Import
                    </vx-button>
                </vx-sticky-footer>
            </form-wrapper>
        </form-container>
    </kiosk-layout>
</template>

<script setup>
import { VxButton, VxStickyFooter } from '@voxie/frontend-components';
import { ref } from 'vue';
import { faArrowsDownToPeople } from '@fortawesome/pro-solid-svg-icons';
import { useToasted } from '~/composables/useToasted';
import FormWrapper from '~/components/general/FormWrapper.vue';
import { stringifyQueryString } from '~/utils/string';
import FormContainer from '~/components/general/FormContainer.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import KioskTeamUserImportNewTemplate from './KioskTeamUserImportNewTemplate.vue';
import KioskTeamUserImportNewUpload from './KioskTeamUserImportNewUpload.vue';
import { adminUsersClient } from '~/services';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const toasted = useToasted();
const file = ref();
const submitting = ref(false);

const selectedFile = (event) => {
    file.value = event;
};

const submit = async () => {
    if (submitting.value || !file.value) {
        return;
    }
    submitting.value = true;

    try {
        const { data } = await adminUsersClient.generateImportPresignedUrl(props.teamId, file.value.name);

        if (!data?.upload_url) {
            throw new Error('Could not parse the upload url');
        }

        await adminUsersClient.importCsvFileToS3(data.upload_url, file.value);

        window.location.assign(
            `/kiosk/teams/${props.teamId}/users/imports?${stringifyQueryString({
                import_id: data.import_id,
                file_name: file.value.name,
                success: 1,
            })}`
        );
    } catch (error) {
        console.error(error);
        toasted.global.platform_error();
    } finally {
        submitting.value = false;
    }
};
</script>
